import { cn } from "@/lib/utils";

import PageTitle, { PageTitleProps } from "@/components/Common/PageTitle";
import { useShortcutSubContext } from "@/context/ShortcutContext";

interface PageProps extends PageTitleProps {
  children: React.ReactNode | React.ReactNode[];
  options?: React.ReactNode | React.ReactNode[];
  changePageMetadata?: boolean;
  className?: string;
  hideTitleOnPage?: boolean;
  shortCutContext?: string;
  style?: React.CSSProperties;
}

export default function Page(props: PageProps) {
  useShortcutSubContext(props.shortCutContext);

  return (
    <div className={cn("min-w-0 py-0", props.className)} style={props.style}>
      <div
        data-slot="page-header"
        className={cn(
          "flex flex-col justify-between gap-2 pb-2 md:flex-row md:items-center md:gap-4",
          props.hideTitleOnPage &&
            !props.componentRight &&
            !props.options &&
            "hidden",
        )}
      >
        <PageTitle
          changePageMetadata={props.changePageMetadata}
          title={props.title}
          componentRight={props.componentRight}
          isInsidePage={true}
          hideTitleOnPage={props.hideTitleOnPage}
        />
        {props.options}
      </div>
      {props.children}
    </div>
  );
}
